import React from 'react';
import ImpactMetricsCard from './ImpactMetricsCard';

const ImpactDashboard = () => {
  const impactMetrics = [
    {
      id: 1,
      icon: "Clock",
      value: "12,450",
      label: "Volunteer Hours Contributed",
      change: 23,
      color: "primary"
    },
    {
      id: 2,
      icon: "Users",
      value: "8,750",
      label: "Community Members Served",
      change: 18,
      color: "success"
    },
    {
      id: 3,
      icon: "DollarSign",
      value: "LKR 2.8M",
      label: "Funds Raised for Local Causes",
      change: 31,
      color: "secondary"
    },
    {
      id: 4,
      icon: "Award",
      value: "145",
      label: "Leadership Positions Developed",
      change: 12,
      color: "warning"
    }
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Our Impact Dashboard
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Real-time metrics showcasing our commitment to community service and leadership development across Colombo Circle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {impactMetrics.map((metric) => (
            <ImpactMetricsCard
              key={metric.id}
              icon={metric.icon}
              value={metric.value}
              label={metric.label}
              change={metric.change}
              color={metric.color}
            />
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground">
            Data updated as of July 2025 • Impact measured since club inception in 2018
          </p>
        </div>
      </div>
    </section>
  );
};

export default ImpactDashboard;